export const SocialData = [
    {
        platform: "Instagram",
        link: "https://www.instagram.com/ranjeet_b10/",
        icon: require("../../assets/icons/instagram.png").default,
    },
    {
        platform: "Github",
        link: "https://www.github.com/Wxld/",
        icon: require("../../assets/icons/github.png").default,
    },
    {
        platform: "Linkedin",
        link: "https://www.linkedin.com/in/ranjeet-bansode-ba1b98203/",
        icon: require("../../assets/icons/linkedin.png").default,
    },
];